import styled from "styled-components";

export const PermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px;
  gap: 16px;
`;

export const PermissionsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PermissionsHeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > button:last-child {
    padding: 4px 0px;
  }
`;

export const PermissionsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PermissionItem = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  padding-left: 16px;
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 40%;
    transform: translateY(-50%);
    color: ${(props) => props.theme.colors.text};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoItemRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props?.gapSpacing ? props.gapSpacing : '4px')};
  justify-content: flex-start;
  align-items: center;
`
